import * as React from "react";

import {
  Button,
  Menu,
  MenuTrigger,
  MenuList,
  MenuItem,
  MenuPopover,
  makeStyles,
  shorthands,
} from "@fluentui/react-components";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  button: {
    backgroundColor: "transparent !important",
    minWidth: "auto",
    ...shorthands.padding("0", "0", "0", "0"),
  },

  menuItem: {
    backgroundColor: "#F5F5F5",
  },
});

export const FluentMenu = ({ button, items, selected }) => {
  const styles = useStyles();

  return (
    <Menu className={styles.root}>
      <MenuTrigger disableButtonEnhancement>
        <Button className={styles.button}>{button}</Button>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          {items?.map((item, index) => (
            <MenuItem
              key={item.Text}
              icon={item.Icon}
              onClick={item.onClick}
              disabled={item.disabled}
              className={`${(selected === item.Value) && selected && item.Value ? styles.menuItem : ""}`}
            >
              {item.Text}
            </MenuItem>
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};

FluentMenu.propTypes = {
  button: PropTypes.any.isRequired,
  items: PropTypes.array.isRequired,
  selected: PropTypes.any,
};
